import React from 'react';

const CourseCard = ({ image, title, description, tags, level, icon }) => {
  return (
    <div className="group bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-2 border border-white/20">
      {/* Image Container */}
      <div className="relative h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
        <div className="absolute top-4 left-4">
          <span className="bg-white/95 backdrop-blur-sm text-brand-dark text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
            {level}
          </span>
        </div>
        <div className="absolute top-4 right-4">
          <span className="text-2xl">{icon}</span>
        </div>
        <div className="absolute bottom-4 right-4">
          {/* <span className="bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
            Miễn phí
          </span> */}
        </div>
      </div>
      
      {/* Content */}
      <div className="p-6 space-y-4">
        <h3 className="text-xl font-bold text-gray-800 group-hover:text-brand-primary transition-colors">
          {title}
        </h3>
        
        {description && (
          <p className="text-gray-600 text-sm leading-relaxed">
            {description}
          </p>
        )}
        
        {/* Tags */}
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, idx) => (
            <span 
              key={idx} 
              className="bg-gradient-to-r from-brand-primary/20 to-brand-secondary/20 text-brand-dark text-xs font-medium px-3 py-1 rounded-full shadow-sm"
            >
              {tag}
            </span>
          ))}
        </div>
        
        {/* Action Button */}
        <div className="pt-2">
          <button className="text-brand-primary font-semibold text-sm hover:text-brand-secondary transition-colors flex items-center group">
            <span>Xem khóa học</span>
            <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard; 